import AmbientWaveformBackground from './ambient-waveform-background'
import LandingAudioPreview from './landing-audio-preview'
import LandingCTA from './landing-cta'
import LandingFounderPricing from './landing-founder-pricing'
import LandingHeroLaunch from './landing-hero-launch'
import LandingPricing from './landing-pricing'

export default function LandingPage() {
	return (
		<main className="text-base-content font-poppins flex min-h-screen flex-col bg-gradient-to-b from-background via-indigo-500/5 to-purple-500/10">
			<AmbientWaveformBackground />
			<div className="relative z-10 flex flex-col">
				<LandingHeroLaunch />
				<LandingFounderPricing />
				<LandingAudioPreview />
				<LandingPricing />
				<LandingCTA />
			</div>
		</main>
	)
}
